import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
// store
import { API, PAGINATION_LIMIT } from "../../../../store/config";
import moment from "moment";
import { isBeforeCurrentTime } from "../../../../store/services/helpers/dates";
// components
import DimmerLoader from "../../../../components/others/DimmerLoader";
import SuperModal from "../../../../components/modals/SuperModal";
import VerificationForm from "../../provider/activities/VerificationForm";
import { Table, Pagination, Button, Icon, Header, Card } from "semantic-ui-react";

// component
function OrderedEventsTable({ orders, setOrders, isLoading }) {
    const user = useSelector((state) => state.user);
    // eslint-disable-next-line
    const [ready, setReady] = useState(false)
    const [isMobile, setIsMobile] = useState(false)
    // eslint-disable-next-line
    const [tableData, setTableData] = useState(
        orders.slice(0, PAGINATION_LIMIT)
    );

    // set data to table
    useEffect(() => {
        setTableData(orders.slice(0, PAGINATION_LIMIT));
        setReady(true)
    }, [orders]);

    useEffect(() => {
        const media = window.matchMedia("(max-width: 768px)");
        const handleChange = () => setIsMobile(media.matches);
        handleChange();
        if (media.addEventListener) {
            media.addEventListener("change", handleChange);
        } else {
            media.addListener(handleChange);
        }
        return () => {
            if (media.removeEventListener) {
                media.removeEventListener("change", handleChange);
            } else {
                media.removeListener(handleChange);
            }
        };
    }, []);

    const handleChangePage = (event, data) => {
        setReady(false)
        setTableData(
            orders.slice(
                data.activePage * PAGINATION_LIMIT - PAGINATION_LIMIT,
                data.activePage * PAGINATION_LIMIT
            )
        );
        setReady(true)
    };

    const manageVerification = (status, orderId) => {
        if (status === 200) {
            setOrders(prevState => prevState.filter(order => {
                if (order.id === orderId) {
                    order.is_used = true
                }

                return order
            }))
        }
    }

    // template
    const totalPages = Math.ceil(orders.filter(o => o.show).length / PAGINATION_LIMIT) || 1;

    return (
        <Fragment>
            <DimmerLoader active={isLoading} />
            {isMobile ? (
                <div>
                    {tableData.filter(o => o.show).length === 0 && (
                        <Card fluid style={{ borderRadius: "16px", textAlign: "center", boxShadow: "0 4px 16px rgba(0,0,0,0.06)", border: "1px solid rgba(0,0,0,0.06)" }}>
                            <Card.Content style={{ padding: "2rem 1rem" }}>
                                <div style={{ color: "rgba(0,0,0,0.4)", marginBottom: "0.5rem", display: "flex", justifyContent: "center" }}>
                                    <Icon name="inbox" style={{ fontSize: "2.5rem", margin: 0 }} />
                                </div>
                                <strong style={{ fontSize: "0.95rem", color: "rgba(0,0,0,0.7)", lineHeight: 1.4 }}>Neboli najdené žiadne záznamy</strong>
                            </Card.Content>
                        </Card>
                    )}
                    {tableData.map((order) => (
                        order.show && (
                            <Card key={order.id} fluid style={{ marginBottom: "1rem", borderRadius: "16px", overflow: "hidden", boxShadow: "0 4px 16px rgba(0,0,0,0.08)", border: "1px solid rgba(0,0,0,0.06)", background: "#fff" }}>
                                <Card.Content style={{ padding: "1rem 1.1rem", background: order.is_refunded ? "linear-gradient(135deg, rgba(219,40,40,0.04) 0%, rgba(255,255,255,0) 100%)" : order.is_used ? "linear-gradient(135deg, rgba(0,166,81,0.04) 0%, rgba(255,255,255,0) 100%)" : "linear-gradient(135deg, rgba(242,113,28,0.04) 0%, rgba(255,255,255,0) 100%)" }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "0.8rem" }}>
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{ fontSize: "0.7rem", fontWeight: 600, color: "rgba(0,0,0,0.45)", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "0.3rem" }}>Aktivita</div>
                                            <div style={{ fontWeight: 700, fontSize: "1rem", color: "#1a1a1a", lineHeight: 1.3, marginBottom: "0.4rem" }}>{order.product_name}</div>
                                            <div style={{ display: "flex", gap: "0.4rem", fontSize: "0.85rem", color: "rgba(0,0,0,0.6)" }}>
                                                <Icon name="map marker alternate" style={{ margin: 0, fontSize: "0.85rem" }} />
                                                <span>{order.event?.address}</span>
                                            </div>
                                        </div>
                                        <div style={{ display: "inline-flex", justifyContent: "center", padding: "0.35rem 0.75rem", borderRadius: "20px", background: order.is_refunded ? "#db2828" : order.is_used ? "#00a651" : "#f2711c", color: "#fff", fontWeight: 700, fontSize: "0.75rem", lineHeight: 1.2, whiteSpace: "nowrap", boxShadow: order.is_refunded ? "0 2px 8px rgba(219,40,40,0.25)" : order.is_used ? "0 2px 8px rgba(0,166,81,0.25)" : "0 2px 8px rgba(242,113,28,0.25)", marginLeft: "0.5rem" }}>
                                            <Icon name={order.is_refunded ? "times circle" : order.is_used ? "check circle" : "clock outline"} style={{ margin: "0 0.3rem 0 0", fontSize: "0.85rem" }} />
                                            {order.is_refunded ? "Zrušené" : order.is_used ? "Využité" : "Nevyužité"}
                                        </div>
                                    </div>
                                </Card.Content>
                                <Card.Content style={{ padding: "1rem 1.1rem", background: "#fafafa" }}>
                                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "0.75rem" }}>
                                        <div style={{ padding: "0.65rem 0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)" }}>
                                            <div style={{ marginBottom: "0.4rem", paddingLeft: "0.15rem" }}>
                                                <Icon name="calendar check" style={{ margin: "0 0.3rem 0 0", fontSize: "0.75rem", color: "rgba(0,0,0,0.4)" }} />
                                                <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px" }}>Termín</span>
                                            </div>
                                            <div style={{ fontWeight: 700, fontSize: "0.85rem", color: "#1a1a1a", paddingLeft: "0.15rem" }}>
                                                {moment(order.event?.starts, "YYYY-MM-DD HH:mm").format("DD.MM.YYYY HH:mm")}
                                            </div>
                                        </div>
                                        <div style={{ padding: "0.65rem 0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)" }}>
                                            <div style={{ marginBottom: "0.4rem", paddingLeft: "0.15rem" }}>
                                                <Icon name="euro sign" style={{ margin: "0 0.3rem 0 0", fontSize: "0.75rem", color: "rgba(0,0,0,0.4)" }} />
                                                <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px" }}>{user.is_town ? "Príspevok" : "Suma"}</span>
                                            </div>
                                            <div style={{ fontWeight: 700, fontSize: "1.05rem", color: "#1a1a1a", paddingLeft: "0.15rem" }}>{order.price} €</div>
                                        </div>
                                        <div style={{ padding: "0.65rem 0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)" }}>
                                            <div style={{ marginBottom: "0.4rem", paddingLeft: "0.15rem" }}>
                                                <Icon name="user" style={{ margin: "0 0.3rem 0 0", fontSize: "0.75rem", color: "rgba(0,0,0,0.4)" }} />
                                                <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px" }}>Objednal</span>
                                            </div>
                                            <div style={{ fontWeight: 700, fontSize: "0.85rem", color: "#1a1a1a", paddingLeft: "0.15rem" }}>{order.owner?.firstname} {order.owner?.lastname}</div>
                                        </div>
                                        <div style={{ padding: "0.65rem 0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)" }}>
                                            <div style={{ marginBottom: "0.4rem", paddingLeft: "0.15rem" }}>
                                                <Icon name="calendar" style={{ margin: "0 0.3rem 0 0", fontSize: "0.75rem", color: "rgba(0,0,0,0.4)" }} />
                                                <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px" }}>Objednané</span>
                                            </div>
                                            <div style={{ fontWeight: 700, fontSize: "0.85rem", color: "#1a1a1a", paddingLeft: "0.15rem" }}>{moment(order.created).format("DD.MM.YYYY")}</div>
                                        </div>
                                    </div>
                                </Card.Content>
                                {(isBeforeCurrentTime(order.event?.starts) && ((!order.is_refunded && !order.is_used) || order.storno_record_id)) && (
                                    <Card.Content style={{ padding: "0.75rem 1.1rem", background: "#f8f9fa", borderTop: "1px solid rgba(0,0,0,0.08)" }}>
                                        <div style={{ display: "flex", gap: "0.6rem", flexWrap: "wrap" }}>
                                            {(!order.is_refunded && !order.is_used) && (
                                                <SuperModal
                                                    trigger={
                                                        <Button fluid style={{ background: "var(--primary)", color: "#fff", borderRadius: "8px", fontWeight: 600, flex: 1 }}>
                                                            <Icon name="check circle" style={{ margin: "0 0.5rem 0 0" }} />
                                                            Overiť
                                                        </Button>
                                                    }
                                                    content={
                                                        <VerificationForm
                                                            onVerification={(status) => manageVerification(status, order.id)}
                                                        />
                                                    }
                                                />
                                            )}
                                            {order.storno_record_id && (
                                                <a
                                                    href={API.STORNO + order.storno_record_id + '/docs/'}
                                                    rel="noopener noreferrer"
                                                    target="_blank"
                                                    style={{ flex: (!order.is_refunded && !order.is_used) ? "0 0 auto" : 1, textDecoration: "none" }}
                                                >
                                                    <Button fluid style={{ background: "#fff", color: "var(--primary)", border: "1px solid var(--primary)", borderRadius: "8px", fontWeight: 600 }}>
                                                        <Icon name="file pdf" style={{ margin: "0 0.5rem 0 0" }} />
                                                        {(!order.is_refunded && !order.is_used) ? "" : "Stiahnuť doklad"}
                                                    </Button>
                                                </a>
                                            )}
                                        </div>
                                    </Card.Content>
                                )}
                            </Card>
                        )
                    ))}
                    {totalPages > 1 && (
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "1.5rem", marginBottom: "1rem" }}>
                            <Pagination
                                defaultActivePage={1}
                                totalPages={totalPages}
                                onPageChange={handleChangePage}
                                boundaryRange={0}
                                siblingRange={1}
                            />
                        </div>
                    )}
                </div>
            ) : (
                <Card fluid style={{ borderRadius: "8px", boxShadow: "none", border: "1px solid #e0e0e0" }}>
                    <Card.Content style={{ padding: "0.5rem 0.75rem" }}>
                        <div style={{ overflowX: "auto" }}>
                            <Table striped unstackable style={{ minWidth: "1100px" }}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Názov aktivity</Table.HeaderCell>
                                        <Table.HeaderCell>Dátum termínu</Table.HeaderCell>
                                        <Table.HeaderCell>Objednal</Table.HeaderCell>
                                        <Table.HeaderCell>Objednané</Table.HeaderCell>
                                        <Table.HeaderCell>{user.is_town ? "Príspevok" : "Suma"}</Table.HeaderCell>
                                        <Table.HeaderCell>Stav</Table.HeaderCell>
                                        <Table.HeaderCell>Akcie</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {tableData.filter(o => o.show).length === 0 &&
                                        <Table.Row>
                                            <Table.Cell colSpan={7} style={{ textAlign: "center", fontWeight: "bold" }}>
                                                Neboli najdené žiadne záznamy
                                            </Table.Cell>
                                        </Table.Row>
                                    }
                                    {tableData.map((order) => (
                                        order.show && (
                                            <Table.Row key={order.id}>
                                                <Table.Cell>
                                                    <Header as="h4" style={{ marginBottom: "0.2rem" }}>{order.product_name}</Header>
                                                    <Icon name="map marker alternate" /> {order.event?.address}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {moment(order.event?.starts, "YYYY-MM-DD HH:mm").format("DD.MM.YYYY HH:mm")}
                                                    <br />
                                                    {order.is_refunded ? (
                                                        <small style={{ color: "red" }}>Zrušené/vratené</small>
                                                    ) : isBeforeCurrentTime(order.event?.starts)
                                                        ? <small style={{ color: "green" }}>Nadchádzajúci</small>
                                                        : <small style={{ color: "red" }}>Po termíne</small>
                                                    }
                                                </Table.Cell>
                                                <Table.Cell>{order.owner?.firstname} {order.owner?.lastname}</Table.Cell>
                                                <Table.Cell>{moment(order.created).format("DD.MM.YYYY")}</Table.Cell>
                                                <Table.Cell>{order.price} €</Table.Cell>
                                                <Table.Cell>
                                                    {order.is_refunded && "Zrušené/vratené"}
                                                    {(order.is_used && !order.is_refunded) && "Využité"}
                                                    {(!order.is_used && !order.is_refunded) && "Nevyužité"}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {isBeforeCurrentTime(order.event?.starts) &&
                                                        <Button.Group size="small">
                                                            {(!order.is_refunded && !order.is_used) &&
                                                                <SuperModal
                                                                    trigger={
                                                                        <Button className="verify-button"> Overiť </Button>
                                                                    }
                                                                    content={
                                                                        <VerificationForm
                                                                            onVerification={(status) => manageVerification(status, order.id)}
                                                                        />
                                                                    }
                                                                />
                                                            }
                                                            {order.storno_record_id &&
                                                                <a
                                                                    href={API.STORNO + order.storno_record_id + '/docs/'}
                                                                    rel="noopener noreferrer"
                                                                    target="_blank"
                                                                    title="Stiahnuť doklad o refundácií"
                                                                >
                                                                    <Button icon="file pdf" style={{ background: 'transparent', color: 'var(--primary)', fontSize: '1.3rem' }} />
                                                                </a>
                                                            }
                                                        </Button.Group>
                                                    }
                                                </Table.Cell>
                                            </Table.Row>
                                        )
                                    ))}
                                </Table.Body>

                                <Table.Footer>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan="7">
                                            <Pagination
                                                defaultActivePage={1}
                                                totalPages={totalPages}
                                                onPageChange={handleChangePage}
                                                boundaryRange={0}
                                                siblingRange={0}
                                            />
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Footer>
                            </Table>
                        </div>
                    </Card.Content>
                </Card>
            )}
        </Fragment>
    );
}

export default OrderedEventsTable;
